import type { DemoScript } from "../types";
import { DASHBOARD_COLLAB_SCRIPT_COPY } from "./dashboard-collab-script.copy";

/**
 * Mesmos passos e alvos do `dashboardScript`, contados do lado da Collab. O
 * passo do filtro é o único que não existe em conta de creator.
 */
export const buildDashboardCollabScript = (): DemoScript => [
  {
    id: "dash-collab-intro",
    narrative: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabIntro.narrative,
    durationMs: 3000,
  },
  {
    id: "dash-collab-scope",
    narrative: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabScope.narrative,
    zoomTargetId: "dashboard-scope",
    disableZoom: true,
    callout: {
      targetId: "dashboard-scope",
      text: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabScope.callout,
    },
    durationMs: 5400,
  },
  {
    id: "dash-collab-greeting",
    narrative: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabGreeting.narrative,
    zoomTargetId: "dashboard-greeting",
    callout: {
      targetId: "dashboard-greeting",
      text: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabGreeting.callout,
    },
    durationMs: 5000,
  },
  {
    id: "dash-collab-overview-1",
    narrative: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabOverview1.narrative,
    durationMs: 1800,
  },
  {
    id: "dash-collab-cards",
    narrative: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabCards.narrative,
    zoomTargetId: "dashboard-social-metrics",
    callout: {
      targetId: "dashboard-social-metrics",
      text: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabCards.callout,
    },
    durationMs: 5600,
  },
  {
    id: "dash-collab-overview-2",
    narrative: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabOverview2.narrative,
    durationMs: 1800,
  },
  {
    id: "dash-collab-kpis",
    narrative: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabKpis.narrative,
    zoomTargetId: "dashboard-kpis",
    callout: {
      targetId: "dashboard-kpis",
      text: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabKpis.callout,
    },
    durationMs: 5400,
  },
  {
    id: "dash-collab-overview-3",
    narrative: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabOverview3.narrative,
    durationMs: 1800,
  },
  {
    id: "dash-collab-posts",
    narrative: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabPosts.narrative,
    zoomTargetId: "dashboard-week-posts",
    callout: {
      targetId: "dashboard-week-posts",
      text: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabPosts.callout,
    },
    durationMs: 5600,
  },
  {
    id: "dash-collab-agenda",
    narrative: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabAgenda.narrative,
    zoomTargetId: "dashboard-agenda",
    callout: {
      targetId: "dashboard-agenda",
      text: DASHBOARD_COLLAB_SCRIPT_COPY.dashCollabAgenda.callout,
    },
    durationMs: 5200,
  },
];
